import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

export const useVehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    setLoading(true);

    // Check if user is a team member
    const { data: { user } } = await supabase.auth.getUser();
    const { data: membership } = await supabase
      .from('team_members')
      .select('owner_id, role')
      .eq('user_id', user.id)
      .single();

    let query = supabase
      .from('vehicles')
      .select('*, vehicle_photos(*)')
      .order('created_at', { ascending: false });

    // The RLS policy handles filtering automatically
    const { data, error } = await query;
    if (error) toast.error('Failed to load vehicles');
    else setVehicles(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  const createVehicle = async (values) => {
    const { data: { user } } = await supabase.auth.getUser();

    // If team member, create under owner's ID
    const { data: membership } = await supabase
      .from('team_members')
      .select('owner_id, role')
      .eq('user_id', user.id)
      .eq('status', 'active')
      .single();

    const ownerId = membership?.owner_id || user.id;
    const { data, error } = await supabase.from('vehicles').insert({ ...values, user_id: ownerId }).select().single();
    if (error) { toast.error('Failed to create vehicle'); throw error; }
    toast.success('Vehicle added!');
    await fetch();
    return data;
  };

  const updateVehicle = async (id, values) => {
    const { error } = await supabase.from('vehicles').update({ ...values, updated_at: new Date().toISOString() }).eq('id', id);
    if (error) { toast.error('Failed to update vehicle'); throw error; }
    toast.success('Vehicle updated!');
    await fetch();
  };

  const deleteVehicle = async (id) => {
    const { error } = await supabase.from('vehicles').delete().eq('id', id);
    if (error) { toast.error('Failed to delete vehicle'); throw error; }
    toast.success('Vehicle deleted');
    await fetch();
  };

  return { vehicles, loading, refetch: fetch, createVehicle, updateVehicle, deleteVehicle };
};